<template>
  <div class="coupon-template">
    <div class="coupon-temp" v-if="coupon_data">
      <div class="coupon-temp-body">
        <div>
          <div class="coupon-temp-item">
            {{ merchant_name }}
          </div>
          <div class="coupon-temp-item coupon-temp-item-strong" style="">
            <div v-if="coupon == 'normal' || coupon == 'voucher'">
              <span style="font-size:20px">￥</span>
              <span style="color:#fff">{{ datas.value1 | yuan }}</span>
            </div>
            <div v-if="coupon == 'discount'">
              <span style="color:#fff">{{ datas.value1 }}</span>
              <span style="font-size:20px">折</span>
            </div>
          </div>
          <div class="coupon-temp-item">
            <div v-if="coupon == 'normal' || coupon == 'discount'">
              {{ this.coupon_data.goods_name }}
            </div>
            <div v-if="coupon == 'voucher'">
              全场可用
            </div>
          </div>
          <!-- 有效期 -->
          <div class="coupon-temp-item">
            <!-- 满减卷 、 折扣卷 -->
            <div
              v-if="
                (coupon == 'normal' || coupon == 'discount') &&
                  this.coupon_data.coupon_use_rule
              "
            >
              {{
                this.coupon_data.coupon_use_rule.coupon_available_time
                  .available_begin_time | dateFormat
              }}
              {{
                this.coupon_data.coupon_use_rule.coupon_available_time
                  .available_end_time | dateFormat
              }}
            </div>
            <!-- 现金卷-->
            <div v-if="coupon == 'voucher'">
              {{ this.coupon_data.available_begin_time | dateFormat }}
              {{ this.coupon_data.available_end_time | dateFormat }}
            </div>
          </div>
        </div>
        <div class="zongxiang">
          现金卷
        </div>
      </div>
    </div>
    <div class="temp-bottom">
      {{ coupon_data.stock_name ? coupon_data.stock_name : datas.stock_name }}
    </div>
  </div>
</template>
<script>
import {
  getBusifavorCouponInfo,
  getNormalCouponInfo
} from "../js/couponInfo.js";

export default {
  props: ["coupon", "datas"],
  data() {
    return {
      merchant_name: localStorage.getItem("merchant_name"),
      coupon_data: {}
    };
  },
  mounted() {
    if (
      this.coupon == "normal" ||
      this.coupon == "discount" ||
      this.coupon == "exchange"
    ) {
      this.coupon_data = getBusifavorCouponInfo(this.datas);
    } else if ((this.coupon = "voucher")) {
      this.coupon_data = getNormalCouponInfo(this.datas);
    }
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.zongxiang {
  width: 130px;
  writing-mode: vertical-rl;
  text-orientation: upright;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}
.coupon-template {
  height: 100%;
  width: 100%;
  max-width: 500px;
  cursor: pointer;
}
.coupon-temp {
  width: 100%;
  height: 200px;
  max-width: 600px;
  min-width: 500px;
  -webkit-mask-image: radial-gradient(
      circle at 10px,
      transparent 10px,
      #9900ff 10.5px
    ),
    radial-gradient(circle at 0px 0px, #9900ff 0px, transparent 0.5px);
  -webkit-mask-position: -10px, -0px -0px;
  -webkit-mask-size: 100% 36px, 100%;
  -webkit-mask-composite: source-out, destination-over;
  mask-composite: subtract, add;
  border-radius: 10px;
  .coupon-temp-body {
    // width: calc(100% - 40px);
    padding-left: 40px;
    height: 200px;
    background: linear-gradient(#ff004b63, #ff004b);

    -webkit-mask-image: radial-gradient(
        circle at right 130px bottom 16px,
        transparent 16px,
        red 16.5px
      ),
      radial-gradient(closest-side circle at 50%, red 99%, transparent 100%);
    -webkit-mask-size: 100%, 4px 15px;
    -webkit-mask-repeat: repeat, repeat-y;
    -webkit-mask-position: 0 16px, calc(100% - 128px);
    -webkit-mask-composite: source-out;
    mask-composite: subtract;

    color: rgb(255, 255, 255) !important;
    display: flex;
    justify-content: space-between;
    .coupon-temp-item {
      height: 40px;
      width: 100%;
      display: flex;
      align-items: center;
      user-select: none;
    }
    .coupon-temp-item-strong {
      height: 60px;
      font-size: 60px;
    }
  }
}
.temp-bottom {
  height: 28px;
  // color: #fff;
  font-size: 20px;
}
</style>
